'use client'

import { createContext, useContext, useEffect, useState } from 'react'
import { getMultiLanguageDatas } from '../services/language'

const MultiLanguageContext = createContext(null)

export function MultiLanguageProvider({ children }) {
  const [locale, setLocaleState] = useState('id')
  const [localeFlag, setLocaleFlagState] = useState('/image/indonesia.svg')
  const [multiLanguages, setMultiLanguages] = useState([])
  const [loading, setLoading] = useState(true)

  // Load saved locale on mount
  useEffect(() => {
    const savedLocale = localStorage.getItem('locale')
    if (savedLocale) {
      setLocaleState(savedLocale)
    }
  }, [])

  const setLocale = (value) => {
    switch (value) {
      case 'id':
        setLocaleFlagState('/image/indonesia.svg')
        break;

      case 'en':
        setLocaleFlagState('/image/united-kingdom.svg')
        break;
    
      default:
        setLocaleFlagState('/image/indonesia.svg')
        break;
    }
    setLocaleState(value)
    localStorage.setItem('locale', value)
  }

  const fetchMultiLanguages = async () => {
    const response = await getMultiLanguageDatas(1)
    let datas = response?.data ?? [];
    for (let index = 2; index < response?.meta?.pagination?.pageCount + 1; index++) {
      let responseLoop = await getMultiLanguageDatas(index);
      datas = [
        ...datas,
        ...(responseLoop?.data ?? [])
      ]
    }
    setMultiLanguages(datas)
    setLoading(false)
  }

  const translateByCode = (code) => {
    const objSingle = multiLanguages.find(item => item.kode === code)

    switch (locale) {
      case 'id':
        return objSingle?.kata_kunci
      case 'en':
        return objSingle?.kata_kunci_en
      default:
        return objSingle?.kata_kunci
    }
  }

  useEffect(() => {
    fetchMultiLanguages()
  }, [])

  useEffect(() => {
    const flag = locale === "id" ? "/image/indonesia.svg" : "/image/united-kingdom.svg"
    setLocaleFlagState(flag)
  }, [locale])

  return (
    <MultiLanguageContext.Provider value={{ multiLanguages, locale, setLocale, loading, translateByCode, localeFlag }}>
      {children}
    </MultiLanguageContext.Provider>
  )
}

export const useMultiLanguages = () => useContext(MultiLanguageContext)